type PlaybackWindow = Window & typeof globalThis & {
  __CAMLIN_PLAYBACK_AUDIO_CONTEXT__?: AudioContext | null;
  webkitAudioContext?: typeof AudioContext;
};

function getPlaybackWindow(): PlaybackWindow | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return window as PlaybackWindow;
}

function getAudioContextConstructor(): typeof AudioContext | null {
  const playbackWindow = getPlaybackWindow();
  if (!playbackWindow) {
    return null;
  }

  return playbackWindow.AudioContext || playbackWindow.webkitAudioContext || null;
}

export function getPlaybackAudioContext(): AudioContext | null {
  return getPlaybackWindow()?.__CAMLIN_PLAYBACK_AUDIO_CONTEXT__ ?? null;
}

export async function ensurePlaybackAudioContextRunning(): Promise<AudioContext | null> {
  const playbackWindow = getPlaybackWindow();
  const AudioContextCtor = getAudioContextConstructor();

  if (!playbackWindow || !AudioContextCtor) {
    return null;
  }

  let audioContext = playbackWindow.__CAMLIN_PLAYBACK_AUDIO_CONTEXT__ ?? null;

  if (!audioContext || audioContext.state === 'closed') {
    audioContext = new AudioContextCtor();
    playbackWindow.__CAMLIN_PLAYBACK_AUDIO_CONTEXT__ = audioContext;
  }

  if (audioContext.state === 'suspended') {
    await audioContext.resume();
  }

  return audioContext.state === 'closed' ? null : audioContext;
}
